import type { ReactNode } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { routes } from "~/routes";

import { systemHomeHandle } from "./system-route-paths";

export type SystemHomeTabElements = {
  index: ReactNode;
  directory: ReactNode;
  workflows: ReactNode;
  branches: ReactNode;
  commits: ReactNode;
  changeRequests: ReactNode;
  changeRequestDetail: ReactNode;
  createChangeRequest: ReactNode;
};

export function createSystemHomeTabRoutes(elements: SystemHomeTabElements): RouteObject[] {
  return [
    { index: true, element: elements.index, handle: systemHomeHandle({ tab: "index" }) },
    {
      path: routes.SystemHomeDirectory,
      element: elements.directory,
      handle: systemHomeHandle({ layout: "dashboard", contentLayout: "full", tab: "directory" }),
    },
    {
      path: routes.SystemHomeWorkflows,
      element: elements.workflows,
      handle: systemHomeHandle({ layout: "dashboard", contentLayout: "full", tab: "workflows" }),
    },
    {
      path: routes.SystemHomeBranches,
      element: elements.branches,
      handle: systemHomeHandle({ layout: "dashboard", tab: "branches" }),
    },
    {
      path: routes.SystemHomeCommits,
      element: elements.commits,
      handle: systemHomeHandle({ layout: "dashboard", tab: "commits" }),
    },
    {
      path: routes.SystemHomeChangeRequests,
      element: elements.changeRequests,
      handle: systemHomeHandle({ layout: "dashboard", tab: "change-requests" }),
    },
    {
      path: routes.SystemHomeChangeRequestDetail,
      element: elements.changeRequestDetail,
      handle: systemHomeHandle({ layout: "dashboard", tab: "change-request-detail" }),
    },
    {
      path: routes.SystemHomeCreateChangeRequest,
      element: elements.createChangeRequest,
      handle: systemHomeHandle({ tab: "create-change-request" }),
    },
    { path: "*", element: <Navigate to=".." replace /> },
  ];
}
